import React, { useState, useEffect } from "react";
import { db } from "../db";
import "../assets/styles/main.css";
import PaginationEntriesPerPage from "./PaginationEntriesPerPage";
import ExpenseSorting from "./ExpenseSorting";
import ExpensePagination from "./ExpensePagination";
import { NumericFormat } from "react-number-format";
// import NoResultFound from "../pages/NoResultFound";
import { format } from "date-fns";

const ExpenseLists = ({
  filteredExpenses,
  handleEdit,
  handleDelete,
  activeRow,
  selectedCurrency,
  setActive,
}) => {
  const [userAddedCategories, setUserAddedCategories] = useState([]);
  const [sortBy, setSortBy] = useState("date");
  const [totalExpensesCount, setTotalExpensesCount] = useState(0);
  const [sortOrder, setSortOrder] = useState("desc");

  useEffect(() => {
    const fetchUserAddedCategories = async () => {
      try {
        const categoriesFromDB = await db.categories.toArray();
        setUserAddedCategories(categoriesFromDB);
      } catch (error) {
        console.error("Error fetching user-added categories:", error);
      }
    };
    fetchUserAddedCategories();
  }, []);

  const handleSort = (column) => {
    if (sortBy === column) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy(column);
      setSortOrder("asc");
    }
  };

  const expenses = [...filteredExpenses].sort((a, b) => {
    if (sortBy === "item") {
      return sortOrder === "asc"
        ? a.item.localeCompare(b.item)
        : b.item.localeCompare(a.item);
    } else if (sortBy === "category") {
      return sortOrder === "asc"
        ? String(a.category).localeCompare(String(b.category))
        : String(b.category).localeCompare(String(a.category));
    } else if (sortBy === "amount") {
      return sortOrder === "asc" ? a.amount - b.amount : b.amount - a.amount;
    } else if (sortBy === "quantity") {
      return sortOrder === "asc"
        ? a.quantity - b.quantity
        : b.quantity - a.quantity;
    } else if (sortBy === "date") {
      return sortOrder === "asc"
        ? new Date(a.date) - new Date(b.date)
        : new Date(b.date) - new Date(a.date);
    }
    return 0;
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(() => {
    const storedValue = localStorage.getItem("itemsPerPage") || 10;
    return parseInt(storedValue);
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const totalFilteredExpenses = expenses?.filter(
    (result) => result.isDeleted !== 1
  );
  const totalItemsCount = totalFilteredExpenses.length;

  const currentItems = totalFilteredExpenses.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const totalPages = Math.ceil(totalItemsCount / itemsPerPage);

  const changeItemsPerPage = (event) => {
    const value = event.target.value;
    if (value === "All") {
      setCurrentPage(1);
      setItemsPerPage(totalExpensesCount);
    } else {
      const intValue = parseInt(value);
      setItemsPerPage(intValue);
      setCurrentPage(1);
    }
  };

  useEffect(() => {
    const storedCurrentPage = localStorage.getItem("currentPageExpense");
    const storedItemsPerPage = localStorage.getItem("itemsPerPageExpense");

    if (storedCurrentPage && storedItemsPerPage) {
      setCurrentPage(parseInt(storedCurrentPage));
      setItemsPerPage(parseInt(storedItemsPerPage));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("currentPageExpense", currentPage);
    localStorage.setItem("itemsPerPageExpense", itemsPerPage);
  }, [currentPage, itemsPerPage]);

  window.onbeforeunload = function () {
    localStorage.removeItem("currentPageExpense");
    localStorage.removeItem("itemsPerPageExpense");
  };
  useEffect(() => {
    db.expenses
      .count()
      .then((count) => {
        setTotalExpensesCount(count);
      })
      .catch((error) => {
        console.error("Error fetching total expenses count:", error);
      });
  }, []);

  const [isAnimating, setIsAnimating] = useState(
    sessionStorage.getItem("hasAnimated") !== "true"
  );

  useEffect(() => {
    if (isAnimating) {
      const timer = setTimeout(() => {
        sessionStorage.setItem("hasAnimated", "true");
        setIsAnimating(false);
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [isAnimating]);

  return (
    <div>
      <div className=" expense-list-div fixTableHead">
        <div>
          <table className="table text-size pt-4">
            <ExpenseSorting
              sortBy={sortBy}
              sortOrder={sortOrder}
              handleSort={handleSort}
            />
            <tbody>
              <div
                className={`arrow-container  ${isAnimating ? "animate" : ""}`}
              >
                <div className="arrow">
                  <span class="material-symbols-outlined">
                    line_end_arrow_notch
                  </span>
                </div>
                <div className="arrow">
                  <span class="material-symbols-outlined">
                    line_end_arrow_notch
                  </span>
                </div>
                <div className="arrow">
                  <span class="material-symbols-outlined">
                    line_end_arrow_notch
                  </span>
                </div>
              </div>

              {currentItems.map((expense, index) => (
                <tr
                  key={expense.id}
                  className={activeRow === expense.id ? "ActiveRow " : ""}
                  onClick={() => setActive(expense.id)}
                >
                  <td className="Table-head hide-sm-screen ">
                    {index + 1 + (currentPage - 1) * itemsPerPage}
                  </td>
                  <td className="content-items ">
                    {format(expense.date, "MMM d, yyyy")}
                  </td>
                  <td className="content-items">{expense.item}</td>
                  <td className="noSpace hide-sm-screen content-items ">
                    {
                      userAddedCategories.find(
                        (category) => category.id === parseInt(expense.category)
                      )?.name
                    }
                  </td>
                  <td className="noSpace text-center hide-sm-screen content-items">
                    {expense.quantity}
                  </td>
                  <td className="content-items  ">
                    <div className="currencyIcons float-end ">
                      <NumericFormat
                        value={parseFloat(expense.amount).toFixed(2)}
                        displayType={"text"}
                        thousandsGroupStyle="lakh"
                        thousandSeparator=","
                        className="verticleAlign"
                        decimalScale={2}
                        fixedDecimalScale={true}
                        renderText={(value) => (
                          <span>
                            {value.includes(".00") ? (
                              <span>
                                {value.split(".")[0]}
                                <span style={{ color: "transparent" }}>
                                  .00
                                </span>
                              </span>
                            ) : (
                              value
                            )}
                          </span>
                        )}
                        prefix={selectedCurrency.label}
                      />
                    </div>
                  </td>
                  <td className="noSpace display-center pt-0  ">
                    <button
                      className="btn p-1 me-1 text-success  "
                      onClick={() => {
                        handleEdit(expense.id);
                      }}
                    >
                      <span className="material-symbols-outlined fs-5">
                        edit
                      </span>
                    </button>
                    <button
                      className=" btn p-1 text-danger"
                      onClick={() => handleDelete(expense.id)}
                    >
                      <span className="material-symbols-outlined fs-5">
                        delete
                      </span>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {totalPages === 0 && (
            <div className="text-center pt-3 pb-3">
              <div>
                <img
                  src="assets/images/categoryError.svg"
                  alt=" NoExpensesRecord"
                />
                <p className="text-danger fw-bolder pt-2">
                  There are no expenses item in this category.{" "}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="display-between ">
        <PaginationEntriesPerPage
          value={itemsPerPage}
          totalCount={totalExpensesCount}
          onChange={changeItemsPerPage}
        />
        <ExpensePagination
          currentPage={currentPage}
          totalPages={totalPages}
          paginate={paginate}
        />
      </div>
    </div>
  );
};

export default ExpenseLists;
